import { FormFieldLine } from "../../../../../../components/form-field-line/form-field-line";
import FormFieldLineLayout from "../../../../../../components/layouts/form-field-line-layout/form-field-line-layout";
import { NOTE_TYPE, Note } from "../../../../../../components/note/note";
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import IconLocation from "../../../../../../components/icons/icon-location/icon-location";
import { IPlatformLocation, IReturnMethodAddress } from "../../../../return-method-types";
import { FONT_VARIANT } from "../../../../../../components/fonts/font-props";
import "./address-note.scss";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface Props {
    address: IReturnMethodAddress | IPlatformLocation | undefined; /** This could be a return address or a restocking location */
}

const AddressNote: React.FC<Props> = ({address}: Props)=>{
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-return-method-editor';

    return(
        <FormFieldLineLayout>
            <FormFieldLine label="">
                <Note 
                    type={NOTE_TYPE.INFORMATION} 
                    body={
                            <FontBody2>
                                <div className="address-note">
                                   <div>{getTranslation("NAME", scope)} <FontBody2 variant={FONT_VARIANT.BOLD}>{address?.name}</FontBody2></div>
                                   <div>{getTranslation("ADDRESS_1", scope)} <FontBody2 variant={FONT_VARIANT.BOLD}>{address?.line_1}</FontBody2></div>
                                   <div>{getTranslation("ADDRESS_2", scope)} <FontBody2 variant={FONT_VARIANT.BOLD}>{address?.line_2}</FontBody2></div>
                                   <div>{getTranslation("CITY_NOTE", scope)} <FontBody2 variant={FONT_VARIANT.BOLD}>{address?.city}</FontBody2></div>
                                   <div>{getTranslation("COUNTRY_NOTE", scope)} <FontBody2 variant={FONT_VARIANT.BOLD}>{address?.country}</FontBody2></div>
                                   <div>{getTranslation("STATE_NOTE", scope)} <FontBody2 variant={FONT_VARIANT.BOLD}>{address?.state}</FontBody2></div>
                                   <div>{getTranslation("PHONE_NOTE", scope)} <FontBody2 variant={FONT_VARIANT.BOLD}>{address?.phone}</FontBody2></div>
                                   <div>{getTranslation("ZIP_NOTE", scope)} <FontBody2 variant={FONT_VARIANT.BOLD}>{address?.postal_code}</FontBody2></div>
                                </div>
                            </FontBody2>
                        }
                    IconComponent={IconLocation}
                />
            </FormFieldLine>
        </FormFieldLineLayout>
    );
};

export default AddressNote;